import { Navigate, useLocation } from "react-router-dom"
import ConfirmationLayout from "../../components/ConfirmationLayout"
import { PostDonateStatus } from "../form/components/PostDonateStatus"

export function DonationFailure() {
  const { state } = useLocation()

  if (!state) {
    console.debug(
      "[DonationForm] missing navigation state for failure page, redirecting to form",
    )
    return <Navigate to="/giving/" replace />
  }

  const { errorMessage } = state

  return (
    <ConfirmationLayout>
      <PostDonateStatus
        status="failure"
        heading="Donation failed"
        message={errorMessage}
      />
    </ConfirmationLayout>
  )
}
